// extracted by mini-css-extract-plugin
module.exports = {"TakeDownRequestsForm":"takeDownRequests_TakeDownRequestsForm__lp8HN","message":"takeDownRequests_message__W55HQ","question":"takeDownRequests_question__tvji1"};